export const LOADING_STEP_ICON_KEYS = [
  'compare',
  'checklist',
  'apply',
] as const;
export const MAX_LOADING_STEPS = 3;

export type LoadingStepIconKey = (typeof LOADING_STEP_ICON_KEYS)[number];

export interface LoadingStep {
  label: string;
  icon?: LoadingStepIconKey;
}

export interface LoadingCopy {
  title: string;
  statusLabel: string;
  steps: LoadingStep[];
}

export const DEFAULT_LOADING_COPY: LoadingCopy = {
  title: "We're preparing your matches!",
  statusLabel: 'Preparing your matches',
  steps: [
    { label: 'Compare schools', icon: 'compare' },
    { label: 'Pick your favorite', icon: 'checklist' },
    { label: 'Apply today', icon: 'apply' },
  ],
};
